<template>
  <order-component :delivery="delivery"/>
</template>
<script>

import OrderComponent from './orderComponent'

export default {
  components: {
    OrderComponent,
  },
  data () {
    return {
      delivery: 20
    }
  },
  created () {

  },
  methods: {}
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/order/order/index.vue